import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./components";
import { IndividualsPage } from "./pages/IndividualsPage";
import { BusinessPage } from "./pages/BusinessPage";
import { ContactsPage } from "./pages/ContactsPage";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/individuals" replace />} />
          <Route path="/individuals" element={<IndividualsPage />} />
          <Route path="/business" element={<BusinessPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
